import React from 'react';

const getRibbonLabel = (item, translate) => {
  if (item.label) {
    return item.label;
  }

  return translate(item.labelKey);
};

const RouteRibbonItem = ({ item, navigate, translate }) => {
  const handleClick = () => navigate(item.to);
  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleClick();
    }
  };

  return (
    <span role="button" tabIndex={0} onClick={handleClick} onKeyDown={handleKeyDown}>
      {getRibbonLabel(item, translate)}
    </span>
  );
};

const LinkRibbonItem = ({ item, translate }) => {
  return (
    <a
      href={item.href}
      target={item.target}
      rel={item.rel}
      className={['btn text', item.linkClassName].filter(Boolean).join(' ')}
    >
      {item.iconClassName && <span className={item.iconClassName}></span>}
      {getRibbonLabel(item, translate)}
    </a>
  );
};

const RoleRibbon = ({ tabs = [], navigate, translate, className = 'tabs' }) => {
  if (!tabs.length) {
    return null;
  }

  return (
    <div className={className}>
      <ul>
        {tabs.map((item, index) => (
          <li key={`${item.type}-${item.labelKey || item.label}-${index}`} className={item.className || ''}>
            {item.type === 'link' ? (
              <LinkRibbonItem item={item} translate={translate} />
            ) : (
              <RouteRibbonItem item={item} navigate={navigate} translate={translate} />
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RoleRibbon;